import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(private router: Router) {
    }
    canActivate(): any {
        if (localStorage.getItem('currentUser')) {
            return true;
        }
        this.router.navigate(['/pages/auth/login']);
        return false;
    }
}


@Injectable()
export class LoginGuardService implements CanActivate {

    constructor(private router: Router) {
    }
    canActivate(): any {
        if (!localStorage.getItem('userInfo')) {
            return true;
        }
        this.router.navigate(['/apps/manage-business/businesslist']);
        return false;
    }
}
